import React from "react";

import { TestWrapper } from "@ui/Atoms/TestWrapper";

import { InnerContext } from "../Dialog.context";

import { ActionsProps } from "./Actions.types";
import * as Styled from "./Actions.styled";

export const Actions: React.FC<ActionsProps> = (props): React.ReactElement => {
  const context = React.useContext(InnerContext);

  if (!context) {
    throw new Error("Actions component must be used inside Dialog component");
  }

  return (
    <TestWrapper testId={props.testId}>
      <Styled.Actions
        direction={context.direction}
        childrenSize={React.Children.count(props.children)}
      >
        {props.children}
      </Styled.Actions>
    </TestWrapper>
  );
};
